import { Typography, styled } from "@mui/material"

export const StyledTitle = styled(Typography)`
  font-size: 2rem;
  margin-right: 1em;
  margin-left: 0.5em;
`
